import React, { createRef, useEffect, useState } from 'react';
import CheckBox from '../../../Shared/CheckBox/Checkbox';
import BtnPink from '../../../Shared/Buttons/BtnPink';
import { getTextByType, EsimTextType, EsimTextFieldName } from '../idfEsimTextHelper';
import { PathHistory } from '../IdfSaleEnums';
import { dwhReport, dwhDictionary } from '../dwhReports/dwhGeneralReport';
function EsimPopUp(props) {
  const [hasRead, setHasRead] = useState(false);
  const [showErrorMsg, setShowErrorMsg] = useState(false);

  const popupText = getTextByType(EsimTextFieldName.Popup);

  useEffect(() => {
    dwhReport({ ...dwhDictionary.EsimPopupDisplayed })
  }, []);

  const checkHasRead = () => {
    if (hasRead) {
      props.onEsimPopUpClose(false);
      props.saveToHistory(PathHistory.DeviceSelectionStep2);
      props.setCurrentStep({ current: PathHistory.DeliveryDateStep1, previous: PathHistory.DeviceSelectionStep2 });
      dwhReport({ ...dwhDictionary.EsimPopupButtonClicked });
    } else {
      setShowErrorMsg(true);
    }
  };
  return (
    <div className='esim-pop-up'>
      <div className='svg-icon'>
        <svg width='120' height='120' viewBox='0 0 100 100' fill='none' xmlns='http://www.w3.org/2000/svg'>
          <path
            d='M26.39 22.346c-4.8 2.8 0 11.833 3 16-13-1-9.5 8-7 13 14.5 25 14 22 22 28 9.5 4.5 19.5 0 24-2.5 20.5-18.5 7.5-34.5 3.5-41-2.4-7.2-8.333-7-11-6l-4.5 5c-2.166-3.5-6.9-11.3-8.5-14.5-4.5-4-9.5 2-11.5 4-1.5-3-5-3.5-10-2z'
            fill='#E0C1FF'
          />
          <path
            d='M40.383 17.467a8.056 8.056 0 0 1 10.864 2.716l.136.228 12.634 21.878a1.738 1.738 0 0 1-2.925 1.872l-.085-.134L48.374 22.15a4.58 4.58 0 0 0-8.04 4.376l.108.2 8.212 14.221a1.738 1.738 0 0 1-2.925 1.872l-.085-.133-8.213-14.223a8.053 8.053 0 0 1 2.952-10.996z'
            fill='var(--theme-primary, #810ea9)'
          />
          <path
            d='M30.94 18.32a8.055 8.055 0 0 1 6.828 3.785l.148.246 10.738 18.596a1.738 1.738 0 0 1-2.925 1.872l-.085-.134-10.74-18.597a4.58 4.58 0 0 0-8.047 4.363l.117.215 12.002 20.785a1.738 1.738 0 0 1-2.925 1.871l-.085-.133-12.001-20.783a8.053 8.053 0 0 1 6.974-12.087z'
            fill='var(--theme-primary, #810ea9)'
          />
          <path
            d='M64.824 26.472a8.055 8.055 0 0 1 6.829 3.786l.147.246 6.317 10.939a26.997 26.997 0 0 1 .004 27.004 27.007 27.007 0 0 1-46.55.386l-.23-.389L19.34 47.658a8.053 8.053 0 0 1 2.952-10.996 8.056 8.056 0 0 1 10.863 2.716l.137.228 5.686 9.845a1.738 1.738 0 0 1-2.926 1.872l-.085-.134-5.684-9.844a4.58 4.58 0 0 0-8.041 4.376l.109.2 12.002 20.785a23.53 23.53 0 0 0 40.759.003 23.52 23.52 0 0 0 .217-23.136l-.221-.392-6.318-10.94a4.579 4.579 0 0 0-8.047 4.363l.117.215 3.158 5.47c.48.831.196 1.895-.636 2.374-5.211 3.009-6.996 9.67-3.988 14.88a1.738 1.738 0 1 1-3.01 1.74c-3.634-6.293-1.967-14.19 3.616-18.525l.191-.146-2.34-4.053a8.053 8.053 0 0 1-.154-7.788l.149-.27a8.055 8.055 0 0 1 6.98-4.029zM23.543 71.122a1.738 1.738 0 0 1 2.374.639 33.492 33.492 0 0 0 9.937 10.811 1.738 1.738 0 0 1-1.982 2.856 36.966 36.966 0 0 1-10.968-11.933 1.738 1.738 0 0 1 .64-2.373zM64.838 16.262a18.153 18.153 0 0 1 15.727 9.081 1.738 1.738 0 0 1-3.01 1.737 14.677 14.677 0 0 0-12.716-7.342 1.738 1.738 0 1 1 0-3.476z'
            fill='var(--theme-primary, #810ea9)'
          />
        </svg>
        <div className='second-title idf-title-extra-bold'>אם רכשת eSIM חשוב לדעת</div>
        <div className='grid-esim-container'>
          <ul>
            {popupText?.map((text, index) => <li key={index}>{text}</li>)}
          </ul>
        </div>
        <CheckBox label='קראתי והבנתי' onCheck={() => setHasRead(true)} onUncheck={() => setHasRead(false)}></CheckBox>
        {showErrorMsg && <span className='error-msg-email'>יש לאשר שקראתי והבנתי</span>}
        <BtnPink onclick={checkHasRead} text='אישור והמשך'></BtnPink>
      </div>
    </div>
  );
}

export default EsimPopUp;
